module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: _vm.isShow ? 'is-active' : ''
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('video', {
    attrs: {
      "src": _vm.videolink,
      "controls": "controls",
      "loop": "false",
      "preload": "auto",
      "autoplay": "autoplay"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a56be6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 447
// module chunks = 1